import { SVGProps } from "react";

export function ChatIcon({
  width = 24,
  height = 24,
  viewBox = "0 0 24 24",
  stroke = "#667085",
  strokeWidth = 1,
  xmlns = "http://www.w3.org/2000/svg",
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns={xmlns}
      {...props}
    >
      <path
        d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CircleChatIcon({
  width = 35,
  height = 32,
  viewBox = "0 0 35 32",
  stroke = "#FCFCFD",
  xmlns = "http://www.w3.org/2000/svg",
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns={xmlns}
      {...props}
    >
      <g clipPath="url(#clip0_8691_204194)">
        <path
          d="M18.5 29C25.4036 29 31 23.4036 31 16.5C31 9.59644 25.4036 4 18.5 4C11.5964 4 6 9.59644 6 16.5C6 23.4036 11.5964 29 18.5 29Z"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M24.125 18.375C24.125 18.7065 23.9933 19.0245 23.7589 19.2589C23.5245 19.4933 23.2065 19.625 22.875 19.625H15.375L12.875 22.125V12.125C12.875 11.7935 13.0067 11.4755 13.2411 11.2411C13.4755 11.0067 13.7935 10.875 14.125 10.875H22.875C23.2065 10.875 23.5245 11.0067 23.7589 11.2411C23.9933 11.4755 24.125 11.7935 24.125 12.125V18.375Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <clipPath id="clip0_8691_204194">
          <rect
            width="27"
            height="27"
            fill="white"
            transform="translate(5 3)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SmCircleChatIcon({
  width = 25,
  height = 25,
  viewBox = "0 0 25 25",
  stroke = "#1D2939",
  xmlns = "http://www.w3.org/2000/svg",
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns={xmlns}
      {...props}
    >
      <g clipPath="url(#clip0_15152_53056)">
        <path
          d="M12.0554 23.898C18.1919 23.898 23.1666 18.9234 23.1666 12.7869C23.1666 6.65039 18.1919 1.67578 12.0554 1.67578C5.91895 1.67578 0.944336 6.65039 0.944336 12.7869C0.944336 18.9234 5.91895 23.898 12.0554 23.898Z"
          stroke="#1D2939"
          strokeWidth="0.888889"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M17.0557 14.4538C17.0557 14.7485 16.9386 15.0311 16.7302 15.2394C16.5219 15.4478 16.2392 15.5649 15.9446 15.5649H9.27789L7.05566 17.7871V8.89822C7.05566 8.60354 7.17273 8.32092 7.3811 8.11255C7.58947 7.90417 7.87209 7.78711 8.16678 7.78711H15.9446C16.2392 7.78711 16.5219 7.90417 16.7302 8.11255C16.9386 8.32092 17.0557 8.60354 17.0557 8.89822V14.4538Z"
        stroke="#101828"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <clipPath id="clip0_15152_53056">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.0556641 0.786865)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SmChatFAQIcon({
  stroke = "#667085",
  xmlns = "http://www.w3.org/2000/svg",
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={15}
      height={15}
      viewBox={"0 0 15 15"}
      fill="none"
      xmlns={xmlns}
      {...props}
    >
      <g clipPath="url(#clip0_17619_7418)">
        <path
          d="M11.25 9.36804H3.75L1.25 11.868V1.86804C1.25 1.70228 1.31585 1.54331 1.43306 1.4261C1.55027 1.30889 1.70924 1.24304 1.875 1.24304H11.25C11.4158 1.24304 11.5747 1.30889 11.6919 1.4261C11.8092 1.54331 11.875 1.70228 11.875 1.86804V8.74304C11.875 8.9088 11.8092 9.06777 11.6919 9.18498C11.5747 9.30219 11.4158 9.36804 11.25 9.36804ZM14.375 5.61804V14.368L11.875 11.868H5C4.83424 11.868 4.67527 11.8022 4.55806 11.685C4.44085 11.5678 4.375 11.4088 4.375 11.243V10.618H13.125V4.99304H13.75C13.9158 4.99304 14.0747 5.05889 14.1919 5.1761C14.3092 5.29331 14.375 5.45228 14.375 5.61804ZM5.11875 2.49304C4.575 2.49304 4.1375 2.61804 3.8 2.86179C3.475 3.11804 3.3125 3.47429 3.31875 3.96804L3.325 3.98679H4.53125C4.5375 3.79929 4.59375 3.65554 4.70625 3.55554C4.82198 3.45957 4.96844 3.40853 5.11875 3.41179C5.3125 3.41179 5.475 3.47429 5.5875 3.58679C5.7 3.70554 5.75 3.86804 5.75 4.05554C5.75 4.25554 5.70625 4.42429 5.60625 4.56804C5.51875 4.71179 5.3875 4.83679 5.225 4.93679C4.90625 5.14929 4.6875 5.33679 4.56875 5.50554C4.44375 5.66804 4.375 5.93054 4.375 6.24304H5.625C5.625 6.04929 5.65 5.89304 5.70625 5.78054C5.7625 5.66804 5.86875 5.55554 6.025 5.45554C6.30625 5.30554 6.5375 5.12429 6.71875 4.87429C6.9 4.62429 6.99375 4.36804 6.99375 4.05554C6.99375 3.58054 6.825 3.19929 6.4875 2.91804C6.15625 2.63679 5.7 2.49304 5.11875 2.49304ZM4.375 6.86804V8.11804H5.625V6.86804H4.375ZM8.125 8.11804H9.375V6.86804H8.125V8.11804ZM8.125 2.49304V6.24304H9.375V2.49304H8.125Z"
          fill="#667085"
        />
      </g>
      <defs>
        <clipPath id="clip0_17619_7418">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0 -0.00695801)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SmChatIcon({
  stroke = "#667085",
  strokeWidth = 1,
  xmlns = "http://www.w3.org/2000/svg",
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={15}
      height={16}
      viewBox={"0 0 15 16"}
      fill="none"
      xmlns={xmlns}
      {...props}
    >
      <path
        d="M13.125 9.875C13.125 10.2065 12.9933 10.5245 12.7589 10.7589C12.5245 10.9933 12.2065 11.125 11.875 11.125H4.375L1.875 13.625V3.625C1.875 3.29348 2.0067 2.97554 2.24112 2.74112C2.47554 2.5067 2.79348 2.375 3.125 2.375H11.875C12.2065 2.375 12.5245 2.5067 12.7589 2.74112C12.9933 2.97554 13.125 3.29348 13.125 3.625V9.875Z"
        stroke="#008934"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
